const questionsData = require('../../content/questionsData.json');

const initialState = questionsData.questions.reduce((obj, q) => ({ ...obj, [q.questionId]: 0}), {});

const selectedAnswersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    default:
      return state;

      case 'SELECT_ANSWER':
      return {
        ...state,
        [payload.question]: payload.answer,
      };

      case 'RESET_ALL_ANSWERS':
        return initialState;
  }
};

export default selectedAnswersReducer;
